import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2e3674e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { URL_POLITICA_PRIVACIDAD } from "@/utils/urlPoliticaPrivacidad";



export default /*#__PURE__*/_defineComponent({
  __name: 'CasillaPrivacidad',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_checkbox, {
    "model-value": _ctx.modelValue,
    color: "primary",
    density: "compact",
    "hide-details": "auto",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = valor => emit('update:modelValue', !!valor))
  }, {
    label: _withCtx(() => [
      _createElementVNode("span", null, [
        _createTextVNode(" He leído y acepto la "),
        _createElementVNode("a", {
          href: _unref(URL_POLITICA_PRIVACIDAD),
          target: "_blank",
          rel: "noopener",
          class: "enlace",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, " política de privacidad ", 8, _hoisted_1)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})